module.exports = "/_next/static/images/27fa87a77c9fad411c5a088cfa983f71-aboutus-xpeer-desktop.jpg.webp";